import LegalLayout from "./LegalLayout";

const sections = [
  {
    heading: "1. Verantwortlicher",
    body: (
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        <br />
        <br />
        <span className="notranslate" translate="no"><span className="text-white">the </span><span className="text-cyan-400">coolpool</span><span className="text-white"> company GmbH</span></span>
        <br />
        Auf'm Reck 65
        <br />
        33334 Gütersloh
        <br />
        <br />
        Telefon: 0175 - 1600677
        <br />
        E-Mail:{" "}
        <a href="mailto:info@cool-pool-company.de" className="text-cyan-300 hover:text-cyan-200 transition-colors">
          info@cool-pool-company.de
        </a>
      </p>
    ),
  },
  {
    heading: "2. Erhebung und Verarbeitung personenbezogener Daten",
    body: (
      <>
        <p>
          Beim Besuch dieser Website werden durch den Hosting-Anbieter automatisch technische Zugriffsdaten
          (sog. Server-Logfiles) verarbeitet, etwa IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp und
          Betriebssystem. Diese Verarbeitung ist technisch erforderlich, um die Website auszuliefern, und
          erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren und
          stabilen Betrieb der Website).
        </p>
        <p className="mt-4">
          Personenbezogene Daten werden darüber hinaus nur verarbeitet, wenn Sie uns diese aktiv mitteilen —
          insbesondere über unser Kontaktformular.
        </p>
      </>
    ),
  },
  {
    heading: "3. Kontaktformular",
    body: (
      <>
        <p>
          Wenn Sie uns über das Kontaktformular eine Anfrage senden, verarbeiten wir Ihre Angaben (Name,
          E-Mail-Adresse, ggf. Telefonnummer und Ihre Nachricht) ausschließlich zur Bearbeitung Ihrer Anfrage
          sowie für mögliche Anschlussfragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO.
        </p>
        <p className="mt-4">
          Ihre Anfrage wird in einer Datenbank gespeichert und zusätzlich per E-Mail an
          info@cool-pool-company.de übermittelt. Für diesen E-Mail-Versand setzen wir einen technischen
          Dienstleister (E-Mail-Übermittlungsdienst) ein, der die Nachricht ausschließlich in unserem Auftrag
          zustellt. Ihre Daten werden nicht an Dritte zu Werbezwecken weitergegeben und nach abschließender
          Bearbeitung Ihrer Anfrage gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.
        </p>
      </>
    ),
  },
  {
    heading: "4. Cookies und Tracking",
    body: (
      <p>
        Diese Website verwendet keine Tracking- oder Analyse-Cookies und bindet keine
        werblichen Drittanbieter-Dienste ein. Es findet kein nutzerbezogenes Tracking statt.
      </p>
    ),
  },
  {
    heading: "5. Externe Inhalte",
    body: (
      <p>
        Diese Website lädt Schriftarten (Google Fonts) sowie einzelne Bilddateien von externen Servern. Dabei
        wird Ihre IP-Adresse an den jeweiligen Anbieter übermittelt, da Ihr Browser die Dateien direkt abruft.
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer ansprechenden,
        technisch zuverlässigen Darstellung).
      </p>
    ),
  },
  {
    heading: "6. Ihre Rechte",
    body: (
      <p>
        Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen
        Daten (Art. 15 DSGVO), deren Berichtigung (Art. 16 DSGVO) oder Löschung (Art. 17 DSGVO), auf
        Einschränkung der Verarbeitung (Art. 18 DSGVO), auf Datenübertragbarkeit (Art. 20 DSGVO) sowie das
        Recht, der Verarbeitung zu widersprechen (Art. 21 DSGVO). Zudem besteht ein Beschwerderecht bei der
        zuständigen Aufsichtsbehörde — für uns ist dies die Landesbeauftragte für Datenschutz und
        Informationsfreiheit Nordrhein-Westfalen (LDI NRW).
      </p>
    ),
  },
  {
    heading: "7. Datensicherheit",
    body: (
      <p>
        Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung. Damit sind Inhalte, die
        Sie über Formulare an uns übermitteln, für Dritte nicht mitlesbar.
      </p>
    ),
  },
  {
    heading: "8. Aktualität dieser Erklärung",
    body: (
      <p>
        Diese Datenschutzerklärung hat den Stand Oktober 2026. Durch die Weiterentwicklung unserer Website
        oder geänderte gesetzliche Vorgaben kann eine Anpassung erforderlich werden.
      </p>
    ),
  },
];

export default function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" testId="datenschutz-page">
      {sections.map((s) => (
        <section key={s.heading} className="mb-9">
          <h2 className="font-display font-semibold text-xl text-white mb-3">{s.heading}</h2>
          <div className="text-sm sm:text-base text-slate-300/90 leading-relaxed font-light">{s.body}</div>
        </section>
      ))}
    </LegalLayout>
  );
}
